import React, { useState, useEffect,useContext } from "react";
import {
  Box,
  Image,
  Text,
  Link,
  VStack,
  Button,
  Select,
  CloseIcon,
  Flex,
} from "native-base";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { DESKTOPSIZE, ORG_ID } from "../../constants";
import StyledButton from "../../components/Button";
import StyledImage from "../../components/Image";

function PinkRepair() {
  const [service, setService] = React.useState("");
  const location = useLocation();
  const RepairImg = require("./repair.png");

  const navigate = useNavigate();
  return (
    <>
          <Flex
            minH={"100vh"}
            direction="column"
            justifyContent={"space-between"}
          >
            <Box>
              <VStack
                alignItems="flex-start"
                space={4}
                px={"4"}
                paddingTop={"4"}
              >
                <Button onPress={() => navigate(-1)} variant={"unstyled"}>
                  <CloseIcon
                      color={'black'}
                    size={"5"}
                  />
                </Button>
              </VStack>
              <VStack
                alignItems={"center"}
                marginBottom={"4"}
                px={4}
                space={"6"}
              >
                <Text
                  color={'black'}
                  fontFamily={'Unna'}
                  fontSize={'36px'}
                  letterSpacing={"0.46px"}
                >
                 Repair or Alter
                </Text>
                
              </VStack>
              <VStack
                marginBottom={"4"}
                px={4}
                space={"6"}
              >
                <Text
                color={'black'}
                fontFamily={'Unna'}
                fontSize={'18px'}
                fontWeight={'700'}
                >
                Do you need to repair or fix the fit of your garment?
                </Text>
              </VStack>
              <VStack
                alignItems={"center"}
                marginBottom={"4"}
                px={4}
                space={"6"}
              >
                <Select
                  selectedValue={service}
                  minWidth="200"
                  width="80"
                  accessibilityLabel={ "Choose an option"}
                  placeholder={"Choose an option"}
                  _selectedItem={{
                    bg: 'black',
                  }}
                  mt={1}
                  onValueChange={(itemValue) => setService(itemValue)}
                  _selectedItem={{
                    bg: 'black',
                    color: "#1341B6", // Set selected item text color
                  _text: { // Ensure the text color is applied if your component structure requires
                    color: "#1341B6",
                  },
                  }}
                  _focus={{
                    borderColor: "#1341B6", // Border color when focused
                    background: "white", // Background color when focused
                  }}
                  style={{
                    borderColor:'#1341B6', // Change border color if a service is selected
                    borderWidth: '1px', 
                  }}
                >
                  
                  <Select.Item label={ "To modify"} value="modify" />
                  <Select.Item label={"Fix"} value="repair" />
                </Select>
              </VStack>
              
                     
              <VStack  alignItems={"center"} px={4} space={"4"} py={"4"}> 
                <Text color={''} fontSize={'12px'} fontFamily={'Unna'} >
                Are you located in France? Repair your damaged item or alter the fit with ease through our repair partner, Tilli.
                </Text>
                <Text color={''} fontSize={'12px'} fontFamily={'Unna'} >
                Click the button below to connect to Tilli’s site and make an appointment with one of their trusted tailors or send in your garment for repair.
                </Text>
              </VStack>

              
              <VStack alignItems={"center"} px={4} space={"4"}>
              
                <Link
                  href="https://tilli.fr/reserver-votre-couturier-a-domicile/"
                  width={window.innerWidth > DESKTOPSIZE ? "40%" : "100%"}
                >
      

                  <StyledButton
                  fontSize={'20px'}
                  fontFamily={'Unna'} 
                    text={'MAKE AN APPOINTMENT'}
                    backgroundColor={'#EEA3AC'}
                    textColor="black"
                    borderColor="transparent"
                    width="100%"
                    height="54px"
                    hoverBackgroundColor="#FFFFFF"
                    hoverTextColor={'black'}
                    hoverBorderColor={'black'}
                  />
                </Link>
              </VStack>
            </Box>
            <VStack alignItems={"center"} marginTop={10}>
              <StyledImage
                width="40%"
                src={RepairImg}
                alt={"Image of the product design 2"}
              />
            </VStack>
          </Flex>
    </>
  );
}

export default PinkRepair;
